// extracted by mini-css-extract-plugin
module.exports = {"tile":"BlogPostTile_tile__8ptz9","title":"BlogPostTile_title__t4YVr","image":"BlogPostTile_image__mvuiA"};